







































import Vue, { PropOptions } from 'vue';

interface LocalProps {
  correct: PropOptions;
  selected: PropOptions;
  label: PropOptions;
  img: PropOptions;
}

export default Vue.extend({
  name: 'HMImageCheckBoxGroupPreview',
  props: {
    correct: {
      type: Boolean,
      default: null,
    },
    displayCorrect: {
      type: Boolean,
      default: true,
    },
    selected: {
      type: Boolean,
      default: null,
    },
    label: {
      type: String,
      default: null,
    },
    img: {
      type: String,
      default: null,
    },
  } as LocalProps,
});
